import React, { useContext } from 'react';
import { TablePagination, Skeleton } from '@mui/material';
import { Context } from '../../../states/Store';
import i18n from '../../../i18n/i18n';

function defaultLabelDisplayedRows({ from, to, count }) {
  return (
    <>
      <b>
        <span>{from}</span>
      </b>{' '}
      {i18n.t('dataGrid.to')} <span>{to}</span> {i18n.t('dataGrid.on')}{' '}
      <b>
        {count !== -1 ? (
          <span>{count}</span>
        ) : (
          <>
            {i18n.t('dataGrid.moreThan')} <span>{to}</span>
          </>
        )}
      </b>
    </>
  );
}

/**
 * Custom pagination works with page displayed datagrid
 */
const EAPagination = ({
  isLoading,
  fromList = false,
  paginationType = 'PAGINATION',
}) => {
  const [state, dispatch] = useContext(Context);

  // Update page in pagination state
  const handleChangePage = (event, pageNumber) => {
    const pagination = {
      rowPerPage: state[paginationType.toLowerCase()].rowPerPage,
      page: pageNumber,
      count: state[paginationType.toLowerCase()].count,
    };
    dispatch({ type: paginationType, [paginationType.toLowerCase()]: pagination });
  };

  // Update rowPerPage in pagination state
  const handleChangeMaxPage = (event) => {
    const pagination = {
      rowPerPage: event.target.value,
      page: state[paginationType.toLowerCase()].page,
      count: state[paginationType.toLowerCase()].count,
    };
    dispatch({ type: paginationType, [paginationType.toLowerCase()]: pagination });
  };

  return !isLoading && state[paginationType.toLowerCase()]?.count >= 0 ? (
    <TablePagination
      count={state[paginationType.toLowerCase()].count || 0}
      onPageChange={(event, pageNumber) => handleChangePage(event, pageNumber)}
      page={state[paginationType.toLowerCase()].page || 0}
      rowsPerPage={state[paginationType.toLowerCase()].rowPerPage || 50}
      onRowsPerPageChange={(event) => handleChangeMaxPage(event)}
      component="div"
      rowsPerPageOptions={[10, 50, 100]}
      labelRowsPerPage={i18n.t('dataGrid.linesByPage')}
      labelDisplayedRows={defaultLabelDisplayedRows}
      sx={
        state.drawerIsOpened
          ? {
              backgroundColor: fromList ? '#f7f8fc' : '',
              position: 'absolute',
              bottom: '0px',
              left: '283px',
              right: 0,
              width: 'calc(100% - 330px)',
              zIndex: 2,
            }
          : {
              position: 'absolute',
              bottom: '20px',
              left: '95px',
              right: 0,
              width: 'calc(100% - 150px)',
              zIndex: 2,
            }
      }
    />
  ) : (
    <div
      style={
        state.drawerIsOpened
          ? {
              position: 'absolute',
              bottom: '40px',
              left: '290px',
              right: 0,
              width: 'calc(100% - 340px)',
              display: 'flex',
              justifyContent: 'space-between',
            }
          : {
              position: 'absolute',
              bottom: '40px',
              left: '95px',
              right: 0,
              width: 'calc(100% - 150px)',
              display: 'flex',
              justifyContent: 'space-between',
            }
      }
    >
      <Skeleton variant="rect" width={'200px'} animation="wave" height={30} />
      <Skeleton variant="rect" width={'200px'} animation="wave" height={30} />
    </div>
  );
};
export default EAPagination;
